import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface ScrollIndicatorProps {
    targetId?: string;
    className?: string;
}

const ScrollIndicator: React.FC<ScrollIndicatorProps> = ({
                                                             targetId = '#profile',
                                                             className = ''
                                                         }) => {
    const handleScroll = () => {
        const element = document.querySelector(targetId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <motion.button
            onClick={handleScroll}
            className={`absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white ${className}`}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.8 }}
        >
            <motion.div
                animate={{ y: [0, 10, 0] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                className="flex flex-col items-center space-y-2"
            >
                <span className="text-sm font-medium tracking-wider">SCROLL</span>
                <ChevronDown size={24} />
            </motion.div>
        </motion.button>
    );
};

export default ScrollIndicator;